import { SET_NOTIFY, CLOSE_NOTIFY } from "./type";

export const setNotify = (alert, confirm, cancel) => ({
  type: SET_NOTIFY,
  payload: { alert, confirm, cancel }
});

export const closeNotify = () => ({ type: CLOSE_NOTIFY, payload: {} });
